import React from 'react';
import { QuestionMarkCircle } from '@cube3/ui/src/exports/subcomponents/QuestionMarkCircle';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';

interface Props {
  disabled: boolean;
  title: string;
}
const defaultTitle =
  'You cannot change the title when exporting multiple videos at once. Export the video one by one if you need a different title.';

export const DisabledTitle = React.memo((props: Props) => {
  const { disabled, title = defaultTitle } = props;
  return (
    <div style={{ marginTop: 10 }}>
      <Typography colorVariant="01" weight="body">
        (Same as file name){' '}
        <QuestionMarkCircle disabled={disabled} title={title} />
      </Typography>
    </div>
  );
});
